import React from 'react';
import { ShieldCheck, Heart, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const SterilizationPage = () => {
  const config = {
    badge: "Sterilization Unit",
    headline: "Spay &",
    headlineItalic: "Neuter Surgery.",
    subtext: "Safe, compassionate sterilization procedures that protect your pet's long-term health and contribute to responsible pet population management.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Sterilization at Dr. Suresh Pet Care — Spaying and Neutering Excellence",
    stats: [
      { value: 3000, suffix: '+', label: 'Sterilizations Done' },
      { value: 99.8, suffix: '%', label: 'Procedure Safety Rate' },
      { value: 10, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Post-Op Monitoring' },
    ],
    services: [
      {
        title: "Female Spaying (OHE)",
        icon: <Heart size={28} />,
        desc: "Ovariohysterectomy to eliminate pyometra risk, prevent mammary tumors, and provide hormonal stability.",
        specs: ["Full OHE", "Laparoscopic Option", "Pre-Op Bloodwork", "Post-Op Care"],
        color: "from-pink-500/10 to-primary/10"
      },
      {
        title: "Male Neutering",
        icon: <ShieldCheck size={28} />,
        desc: "Orchiectomy to prevent testicular cancer, reduce aggression, and eliminate breeding behaviours.",
        specs: ["Bilateral Orchiectomy", "Cryptorchid Neuter", "Pre-Op Bloodwork", "Post-Op Recovery"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Pre-Anaesthesia Protocol",
        icon: <Activity size={28} />,
        desc: "Comprehensive pre-surgical screening including bloodwork and cardiac assessment for maximum safety.",
        specs: ["CBC & Chemistry", "ECG Screening", "IV Cannulation", "Anaesthesia Monitoring"],
        color: "from-green-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Sterilization",
    sectionItalic: "Services.",
    warningTitle: "Key Health",
    warningItalic: "Benefits.",
    warningText: "Sterilization is one of the most impactful health decisions you can make for your pet. The benefits extend far beyond population control.",
    warnings: [
      { name: "Cancer Prevention", desc: "Eliminates risk of ovarian, uterine, and testicular cancers in your pet.", icon: "🛡️" },
      { name: "Pyometra Prevention", desc: "Spaying removes the lifetime risk of life-threatening uterine infection.", icon: "💚" },
      { name: "Behaviour Improvement", desc: "Reduces roaming, aggression, and marking behaviours significantly.", icon: "🐾" },
      { name: "Longer Lifespan", desc: "Sterilized pets statistically live longer, healthier lives than intact pets.", icon: "❤️" },
    ],
    ctaBadge: "Safe Sterilization",
    ctaTitle: "The Surgical",
    ctaItalic: "Expertise.",
    ctaText: "Our surgical team uses the highest anaesthesia standards and post-operative care to ensure a safe, comfortable sterilization experience for your pet.",
    ctaBtn: "Book Sterilization",
    seoText: "Safe dog and cat spaying and neutering in Hyderabad. Professional sterilization procedures at Dr. Suresh Pet Care. OHE and orchiectomy for pets.",
    glowColor: "pink-500"
  };

  return (
    <>
      <SEO 
        title="Pet Sterilization & Neutering"
        description="Safe and professional spaying and neutering procedures for dogs and cats at Dr. Suresh Pet Care, Hyderabad. Population control and health benefits."
        canonical="/sterilization"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default SterilizationPage;
